<app-loader *ngIf="show"></app-loader>
<div fxLayout="column" fxLayoutGap="20px" *ngIf="approval !== undefined" ngStyle.xs="margin:0% 3vw;  padding-top: 2vh;padding-bottom: 3vh;"
  ngStyle.sm="margin: 0% 5vw;  padding-top: 2vh;padding-bottom: 3vh;"
  ngStyle.md="margin: 0% 10vw; padding-top: 3vh;padding-bottom: 5vh;"
  ngStyle.lg="margin: 0% 20vw;  padding-top: 4vh;padding-bottom: 5vh;"
  ngStyle.xl="margin: 0% 20vw;  padding-top: 4vh;padding-bottom: 5vh;">


  <div fxLayout="column" fxLayoutGap="10px">
    <mat-card>
      <div fxLayout="column" fxLayoutGap="20px">
        <!-- Status -->
        <div class="div-user-details" fxLayout="row" fxLayoutGap="10px">
          <img alt="img" [src]=userImage height="75" width="75" style="border-radius: 50%;" />
          <span fxFlexAlign="center" fxLayout="column" fxLayoutGap="5px">
            <span class="text-username">{{approval?.name}}</span>
            <span class="text-light">{{approval?.jobTitle}}</span>
          </span>
        </div>
        <!--Crew Members-->
        <div *ngIf="isProxySiteRequest" fxLayout="column" fxLayoutGap="5px">
          <span class="text-light medium">{{ 'proxy_for' | transloco }}</span>
          <div fxFlex.xs="100" fxLayout="row" fxLayoutGap.xs="10px" class="proxy-member"
            (click)="openCrewDetailDialog(approval)">
            <span><img alt="img"  src="assets/icons/crew_icon.svg"></span>
            <span class="textsmall bold" style="padding-top: 10px" ngClass.xs="text-xs"
              fxFlex>&nbsp;&nbsp;{{crewCount}}&nbsp;{{ 'crew(s)' | transloco }}</span>
          </div>
        </div>
        <div  *ngIf="isProxySiteRequest" class="divider"></div>
        <!-- Facility -->
        <div fxLayout="column" fxLayoutGap="10px">
          <div fxLayout="row" fxLayoutAlign="space-between">
            <span fxLayout="row" fxLayoutGap="10px">
              <img alt="img"  src="assets/images/location@2x.png" class="img-icon" />
              <span fxFlexAlign="center" class="textsmall medium">{{ 'facility' | transloco }}</span>
            </span>
          </div>
          <!--Template For Search Facility :: START-->
          <div class="div-inner" ngClass.xs="div-inner-xs" fxLayout="column" fxLayoutGap="5px">
            <div fxLayout="column" fxLayoutGap="15px" style="padding-bottom: 10px;">
              <span fxLayout="column" fxLayoutGap="5px" *ngIf="approval !== undefined">
                <span class="textLarge bold">{{approval?.facility.facilityName}}</span>
                <span class="textsmaller medium">{{approval?.facility | facility}}</span>
              </span>
            </div>
          </div>
        </div>
        <div class="divider"></div>
        <!-- Compliance -->
        <div fxLayout="column" fxLayoutGap="10px">
          <div fxLayout="row" fxLayoutAlign="space-between">
            <span fxLayout="row" fxLayoutGap="10px">
              <img alt="img"  class="img-icon" src="assets/images/covid.svg" />
              <span dir="auto" class="textsmall medium">{{ 'covid_19_readiness' | transloco }}</span>
            </span>
          </div>
          <div class="div-inner" ngClass.xs="div-inner-xs" fxLayout="column" fxLayoutGap="20px">

            <div fxLayout="column">
              <span fxFlex="100" fxLayout="row" fxLayoutAlign="center" fxLayoutGap="4px">
                <div fxFlex="100" fxLayout="column" fxLayoutAlign="center" fxLayoutGap="10px">
                  <span class="textsmallInner medium">{{ 'site_specific_requirement' | transloco }}</span>
                  <span *ngIf="approval.exemptionNumber !== undefined" fxLayout="column" fxHide="true" fxHide.xs="false"
                    fxLayoutGap="1px">
                    <span class="textsmaller medium" style="color: #ff2422;">{{ 'not_ready' | transloco }}</span>
                    <span class="textsmaller medium"
                      style="color: #ff2422;">{{ 'exmptno' | transloco }}&nbsp;{{ approval.exemptionNumber }}</span>
                  </span>
                </div>
                <div fxFlex="100" fxHide.xs="true" fxLayoutAlign="end start" fxLayoutGap="5px">
                  <span *ngIf="approval.exemptionNumber === undefined" class="textsmaller medium"
                    style="color: #7AC028;">{{ 'ready' | transloco }}</span>
                  <div *ngIf="approval.exemptionNumber !== undefined" fxLayout="column" fxLayoutAlign="center end">
                    <span fxHide.xs="true" class="textsmaller medium"
                      style="color: #ff2422;">{{ 'not_ready' | transloco }}</span>
                    <span fxHide.xs="true" class="textsmaller medium"
                      style="color: #ff2422;">{{ 'exmptno' | transloco }}&nbsp;{{ approval.exemptionNumber }}</span>
                  </div>
                </div>
              </span>
            </div>
          </div>
        </div>
        <div class="divider"></div>
        <!-- Duration -->
        <div fxLayout="column" fxLayoutGap="10px">
          <div fxLayout="row" fxLayoutAlign="space-between">
            <span fxLayout="row" fxLayoutGap="10px">
              <img alt="img"  src="assets/images/duration.png" class="img-icon" />
              <span fxFlexAlign="center" class="textsmall medium">{{ 'duration' | transloco }}</span>
            </span>
          </div>

          <div class="div-inner" ngClass.xs="div-inner-xs" fxLayout="column" fxLayoutGap="10px">
            <div fxLayout="row" fxLayoutGap.xs="0">
              <mat-form-field fxFlex="40">
                <mat-label style="color: #4a4a4a;">{{approval.siteRequestDuration.startDate | date:'d MMM yy'}}
                </mat-label>
                <input matInput [matDatepicker]="frompicker" disabled>
                <mat-datepicker-toggle matSuffix [for]="frompicker"></mat-datepicker-toggle>
                <mat-datepicker touchUi #frompicker></mat-datepicker>
              </mat-form-field>
              <div fxFlex fxFlexAlign="center" fxLayoutAlign="center start" style="max-width: 15px;">
                <span class="textsmallInner medium">{{ 'to' | transloco }}</span>
              </div>
              <mat-form-field fxFlex="40">
                <mat-label style="color: #4a4a4a;">{{approval.siteRequestDuration.endDate | date:'d MMM yy'}}
                </mat-label>
                <input matInput [matDatepicker]="topicker" disabled>
                <mat-datepicker-toggle matSuffix [for]="topicker"></mat-datepicker-toggle>
                <mat-datepicker touchUi #topicker></mat-datepicker>
              </mat-form-field>
            </div>
          </div>
        </div>
        <!-- Approver -->
        <div fxLayout="column" fxLayoutGap="10px">
          <div fxLayout="row" fxLayoutAlign="space-between">
            <span fxLayout="row" fxLayoutGap="10px">
              <img alt="img" src="assets/images/approve.png" class="img-icon" />
              <span fxFlexAlign="center" class="textsmall medium">{{ 'approver' | transloco }}</span>
            </span>
          </div>

          <div class="div-inner" ngClass.xs="div-inner-xs" fxLayout="column" fxLayoutGap="10px">
            <div *ngIf="approval.siteRequestApprover.length === 0">
              <span class="text-appprover  regular">{{'pending_for_approval'|transloco}}</span>
            </div>
            <div fxLayout="row" fxLayout.xs="column" fxLayoutGap="50px" fxLayoutGap.xs="10px"
              *ngIf="approval.siteRequestApprover.length > 0">
              <span fxFlex="50" fxFlex.xs="100" fxLayout="row" fxLayoutAlign="space-between" fxLayoutGap="20px"
                *ngIf="approval.siteRequestApprover.length >= 1">
                <div fxLayout="column" fxLayoutGap="5px">
                  <div fxLayout="column" fxLayoutAlign="center">
                    <span class="text-appprover  regular">{{ 'first_approver' | transloco }}</span>
                  </div>
                  <div fxLayout="column" fxLayoutAlign="center">
                    <span class="textsmallInner medium">{{approval?.siteRequestApprover[0]?.approverName}}</span>
                  </div>
                </div>
                <div fxFlex fxLayoutAlign="end start" fxLayoutGap="5px">
                  <span *ngIf="approval?.siteRequestApprover[0]?.statusId === 2" class="textsmaller medium"
                    style="color: #02ba21">Approved</span>
                  <span *ngIf="approval?.siteRequestApprover[0]?.statusId === 3" class="textsmaller medium"
                    style="color: #ff2422">Rejected</span>
                </div>
              </span>
              <span fxFlex="50" fxFlex.xs="100" fxLayout="row" fxLayoutAlign="space-between" fxLayoutGap="20px"
                *ngIf="approval.siteRequestApprover.length >= 2">
                <div fxLayout="column" fxLayoutGap="5px">
                  <div fxFlex fxLayout="column" fxLayoutAlign="center">
                    <span class="text-appprover  regular">{{ 'second_approver' | transloco }}</span>
                  </div>
                  <div fxLayout="column" fxLayoutAlign="center">
                    <span class="textsmallInner medium">{{approval.siteRequestApprover[1]?.approverName}}</span>
                  </div>
                </div>
                <div fxFlex fxLayoutAlign="end start" fxLayoutGap="5px">
                  <span *ngIf="approval?.siteRequestApprover[1]?.statusId === 2" class="textsmaller medium"
                    style="color: #02ba21">Approved</span>
                  <span *ngIf="approval?.siteRequestApprover[1]?.statusId === 3" class="textsmaller medium"
                    style="color: #ff2422">Rejected</span>
                </div>
              </span>
            </div>
          </div>
        </div>
      </div>
    </mat-card>
  </div>
  <span fxLayout="row" fxLayoutAlign="center center" fxLayoutGap.xs="10px" fxLayoutGap="20px"
    *ngIf="approval.requestStatusId === 1">
    <button mat-raised-button class="action-button reject" (click)="onReject()"
      ngClass.xs="action-button xs reject">Reject</button>
    <button mat-raised-button class="action-button approve" (click)="onApprove()"
      ngClass.xs="action-button xs approve">Approve</button>
  </span>
</div>
